import React from "react";
import { Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import { NOTAVAILABLEIMAGE } from "../../enums/GlobalEnums";

export const RestaurantCard = () => {
  const restaurantData = useSelector(
    (state) => state.onboarding.restaurantDetails
  );
  return (
    <div
      style={{
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "25px",
      }}
      className=" p-3"
    >
      <div className="row align-items-center">
        <div className="col-3 d-flex justify-content-center">
          <Image
            src={
              restaurantData?.logo_url_thumbnails
                ? restaurantData?.logo_url_thumbnails
                : NOTAVAILABLEIMAGE
            }
            width="80px"
            height={"80px"}
            style={{ borderRadius: "50%" }}
          />
        </div>
        <div className="col-9">
          <div className="f18-700">{restaurantData?.restaurant_name || ""}</div>
          <div className="f14-400 mt-1">
            {restaurantData?.selected_cusine?.length
              ? `${restaurantData?.selected_cusine[0]?.title}, `
              : ""}
            {restaurantData?.selected_cusine?.length > 1
              ? `${restaurantData?.selected_cusine[1]?.title}, `
              : ""}
            {restaurantData?.selected_cusine?.length > 2
              ? `${parseInt(restaurantData?.selected_cusine?.length) - 2}+`
              : ""}
          </div>
          <div className="row mt-4 f14-500">
            <div className="col-6 d-flex">
              <Image
                src={restaurantData?.primary_restaurant_type?.icon}
                style={{
                  width: "25px",
                  marginRight: "10px",
                }}
              />
              {restaurantData?.primary_restaurant_type?.title}
            </div>
            <div className="col-6 d-flex">
              <Image
                src={restaurantData?.primary_food_type?.icon}
                style={{
                  width: "25px",
                  marginRight: "10px",
                }}
              />
              {restaurantData?.selected_food_type?.length
                ? `${restaurantData?.selected_food_type[0]?.title}, `
                : ""}
              {restaurantData?.selected_food_type?.length > 1
                ? `${parseInt(restaurantData?.selected_food_type?.length) - 2}+`
                : ""}
            </div>
          </div>
          <div className="row mt-2 f14-500">
            <div className="col-6 d-flex">
              <div
                className="rupees-icon-input"
                style={{
                  marginRight: "10px",
                  border: "1px solid black",
                  borderRadius: "50%",
                  width: "25px",
                  height: "25px",
                  textAlign: "center",
                }}
              >
                <i className="fa fa-inr" aria-hidden="true"></i>
              </div>
              {restaurantData?.cost_for_two} for two
            </div>
            <div className="col-6 d-flex">
              <Image
                src={restaurantData?.primary_other_features?.icon}
                style={{
                  width: "25px",
                  marginRight: "10px",
                }}
              />
              {restaurantData?.primary_other_features?.title}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="f12-500">
        Latitude: {restaurantData?.location?.coordinates[1]} Longitude:{" "}
        {restaurantData?.location?.coordinates[0]}
      </div>
    </div>
  );
};
